module.exports = __webpack_public_path__ + "static/media/firetable-with-wordmark.d4b58588.svg";